import { localFetch } from "./localFetch"

export const getErrors = () => {
  return localFetch(`/api/views/errors`)
}
